<template>
    <div class="purchase-amount-noti">

        <div class="purchase-amount-noti__row">
            <p>
                <span>※구매하신 상품권은 취소교환이 어려우니</span>
                <span>신중히 확인하고 구매해주세요</span>
            </p>
            <v-dialog v-model="shows" max-width="400">
                <template #activator="{attrs, on}">
                    <v-btn text color="primary" class="pa-0" v-bind="attrs" v-on="on"> 교환환불정책 </v-btn>
                </template>
                <v-card>
                    <v-card-title> 교환 환불 정책 </v-card-title>
                    <v-card-text class="purchase-amount-noti__info">
                        <p>교환 환불을 원하시는 고객님께서는 help@daehanbooks.co.kr로 아래의 정보를 전달해주세요.</p>
    
                        <ol class="purchase-amount-noti__list">
                            <li>
                                주민등록증 또는 운전면허증 <br />
                                <small> (뒷자리 가린 이미지) </small>
                            </li>
                            <li>
                                통장 사본 이미지
                            </li>
                            <li>
                                아이디
                            </li>
                            <li>
                                결제금액 및 권종
                            </li>
                        </ol>
    
                        <p>※ 환불시 소비자 보호법에 의거하여10% 수수료를 제외하고 환불 됩니다.</p>
                        <p>※ 환불은 영업일 기준 2~3일 내에 보내주신 통장으로 수수료를 제외하고 입금됩니다.</p>
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <v-btn color="primary" @click="shows = false"> 닫기 </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>

        <div class="purchase-amount-noti__row">
            <p>
                <span>구매 불가시간:</span>
                <span>23:20~24:40(은행 점검시간)</span>
            </p>
        </div>
        <div class="purchase-amount-noti__row">
            <p>
                <span>발송 된 핀은</span>
                <span>구매자 외 충전 및 사용 불가</span>
            </p>
        </div>

        <paysolus-notice class="mt-16px text-center" />
    </div>
</template>

<script>
import PaysolusNotice from "@/components/client/paysolus-notice.vue";

export default {
    components: {
        PaysolusNotice,
    },
    props: {},
    setup: () => ({}),
    data: () => ({
        shows: false,
    }),
    computed: {},
    methods: {},
    watch: {},
    mounted() {},
    beforeUnmount() {},
};
</script>

<style lang="scss" scoped>
.purchase-amount-noti {
    display: flex;
    flex-direction: column;
    gap: 8px;
    text-align: center;
    word-break: keep-all;
    font-size: 1.4rem;

    &__row {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        gap: 4px 8px;

        & > p {
            margin: 0;
            // p 안의 span 은 뜻이 끊기면 안 되는 덩어리다.
            // flex 조각으로 두면 폭이 넉넉할 땐 한 줄로 이어 붙고
            // 모자랄 때만 덩어리 경계에서 접힌다. <br> 로 박으면 넓은 화면에서도 끊긴다.
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            column-gap: 0.25em;
        }
    }

    &__info {
        & > p:not(:last-of-type) {
            margin: 0 0 8px;
        }

        & > ol {
            margin: 24px 0;
        }
    }

    &__list {
        list-style: decimal;
        padding: 0 0 0 24px;

        & > li:not(:last-of-type) {
            margin: 0 0 8px;
        }
    }

    @media (min-width: 768px) {
        font-size: 1.6rem;
    }
}
</style>
